import { get } from "lodash";
import PropTypes from "prop-types";
import React from "react";

import WorkspacePropType from "src/custom-prop-types/workspace";
import { isSearchPage } from "src/util/url";
import { matchPaths } from "src/consts/urlPaths";
import { TAGS_UI_COMPONENTS } from "src/util/consts";
import { useGlobalSearchContext } from "./GlobalSearchContext";
import { useGlobalSearchParallel } from "./globalSearch";
import SearchBox from ".";

const SEARCH_COUNT_LIMIT = 3;

const SearchContainer = ({
  onOptionSelect,
  isMulti = false,
  isCloseOnSelect = true,
  includePeople = true,
  includeGroups = true,
  includeTags = true,
  workspace,
  showExploreLink = false,
  tagsVisibleIn = TAGS_UI_COMPONENTS.DIRECTORY,
  Search = SearchBox,
  emptyStateComponent,
}) => {
  const match = matchPaths();
  const isForSearchPage = isSearchPage(match?.path);
  const customer = get(workspace, "config.customer");
  const tagTypesConfig = get(workspace, "config.tagConfig");

  const {
    defaultSearchScope,
    setDefaultSearchScope,
    peopleFilters,
    groupFilters,
    defaultTeamTypes,
    searchQuery,
  } = useGlobalSearchContext();

  const { loading, error, results, loadingPeople, loadingTeams, loadingTags } =
    useGlobalSearchParallel({
      disabled: isForSearchPage || !searchQuery,
      searchTerm: searchQuery,
      size: SEARCH_COUNT_LIMIT,
      scope: defaultSearchScope,
      peopleFilters,
      groupFilters,
      defaultTeamTypes,
      tagTypesConfig,
      tagsVisibleIn,
      includePeople,
      includeGroups,
      includeTags,
      customer,
    });
  const onDefaultScopeClearCallback = () => {
    setDefaultSearchScope(null);
  };

  return (
    <Search
      isForSearchPage={isForSearchPage}
      isMulti={isMulti}
      isCloseOnSelect={isCloseOnSelect}
      isLoading={loading}
      onOptionSelect={onOptionSelect}
      searchError={error}
      showExploreLink={showExploreLink}
      onDefaultScopeClearCallback={onDefaultScopeClearCallback}
      resultsFormattedData={isForSearchPage ? undefined : results}
      loadingPeople={loadingPeople}
      loadingTeams={loadingTeams}
      loadingTags={loadingTags}
      searchTerm={searchQuery}
      workspace={workspace}
      emptyStateComponent={emptyStateComponent}
    />
  );
};

SearchContainer.propTypes = {
  onOptionSelect: PropTypes.func,
  isCloseOnSelect: PropTypes.bool,
  isMulti: PropTypes.bool,
  includePeople: PropTypes.bool,
  includeGroups: PropTypes.bool,
  workspace: WorkspacePropType,
  showExploreLink: PropTypes.bool,
  tagsVisibleIn: PropTypes.string,
  includeTags: PropTypes.bool,
  Search: PropTypes.elementType,
  emptyStateComponent: PropTypes.node,
};

// Wrap in react memo so state provider change doesn't re-render component
export default SearchContainer;
